// import Sidebar from "../components/Sidebar";
// import Topbar from "../components/Topbar";
// import { useNavigate } from "react-router-dom";
// import {
//   Code2,
//   FlaskConical,
//   FileText,
//   Clock,
//   Target,
// } from "lucide-react";

// export default function Dashboard() {
//   const navigate = useNavigate();

//   // 🔹 TEMP DATA (future: backend se aayega)
//   const stats = [
//     { label: "Problems Solved", value: 124 },
//     { label: "Accuracy", value: "82%" },
//     { label: "Tests Attempted", value: 14 },
//     { label: "Active Streak", value: "6 days" },
//   ];

//   const activities = [
//     {
//       title: "Python Code Executed",
//       desc: "Ran a Python program in Compiler",
//       time: "2 min ago",
//       icon: <Code2 size={16} />,
//     },
//     {
//       title: "MCQ Test Submitted",
//       desc: "DSA Basics Test",
//       time: "1 hour ago",
//       icon: <FileText size={16} />,
//     },
//     {
//       title: "Lab Completed",
//       desc: "Operating Systems Lab – Process Scheduling",
//       time: "Yesterday",
//       icon: <FlaskConical size={16} />,
//     },
//   ];

//   const recommendations = [
//     {
//       title: "Practice Java Input/Output",
//       desc: "Important for KTU exams & coding rounds.",
//       action: () => navigate("/compiler"),
//     },
//     {
//       title: "Attempt DSA MCQ Test",
//       desc: "Strengthen fundamentals before exams.",
//       action: () => navigate("/tests"),
//     },
//     {
//       title: "Complete Linux Commands Lab",
//       desc: "Useful for practical & interviews.",
//       action: () => navigate("/labs"),
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-950">
//       <Sidebar />

//       <div className="ml-64 min-h-screen bg-gray-900 text-gray-300">
//         <Topbar title="Dashboard" />

//         <div className="p-10 space-y-12">
//           {/* HEADER */}
//           <div>
//             <h2 className="text-3xl font-bold text-white mb-2">
//               Welcome back 👋
//             </h2>
//             <p className="text-gray-400">
//               Here's a quick overview of your learning progress.
//             </p>
//           </div>

//           {/* STATS CARDS */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {stats.map((s) => (
//               <div
//                 key={s.label}
//                 className="bg-gray-800/80 border border-gray-700 rounded-xl p-6"
//               >
//                 <p className="text-sm text-gray-400">{s.label}</p>
//                 <h3 className="text-3xl font-bold text-white mt-2">
//                   {s.value}
//                 </h3>
//               </div>
//             ))}
//           </div>

//           {/* QUICK ACTIONS */}
//           <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
//             <ActionCard
//               icon={<Code2 size={28} />}
//               title="Online Compiler"
//               desc="Practice Python, Java & C++ with inputs."
//               onClick={() => navigate("/compiler")}
//             />
//             <ActionCard
//               icon={<FlaskConical size={28} />}
//               title="Labs"
//               desc="Hands-on experiments & simulations."
//               onClick={() => navigate("/labs")}
//             />
//             <ActionCard
//               icon={<FileText size={28} />}
//               title="Tests"
//               desc="Attempt MCQs & coding assessments."
//               onClick={() => navigate("/tests")}
//             />
//           </div>

//           {/* ACTIVITY + RECOMMENDATION */}
//           <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
//             {/* RECENT ACTIVITY */}
//             <div className="xl:col-span-2 bg-gray-800/70 border border-gray-700 rounded-2xl p-6">
//               <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-2">
//                 <Clock size={20} /> Recent Activity
//               </h3>

//               <div className="space-y-4">
//                 {activities.map((a, i) => (
//                   <div
//                     key={i}
//                     className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-800 transition"
//                   >
//                     <div className="text-indigo-400 mt-1">
//                       {a.icon}
//                     </div>
//                     <div className="flex-1">
//                       <p className="text-white font-medium">
//                         {a.title}
//                       </p>
//                       <p className="text-sm text-gray-400">
//                         {a.desc}
//                       </p>
//                     </div>
//                     <span className="text-xs text-gray-500">
//                       {a.time}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* NEXT TASK */}
//             <div className="bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl p-6 text-white shadow-xl">
//               <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
//                 <Target size={20} /> Recommended Next Tasks
//               </h3>

//               <div className="space-y-4">
//                 {recommendations.map((r, i) => (
//                   <div
//                     key={i}
//                     className="bg-black/20 rounded-xl p-4"
//                   >
//                     <p className="font-semibold">{r.title}</p>
//                     <p className="text-sm text-indigo-100 mb-3">
//                       {r.desc}
//                     </p>
//                     <button
//                       onClick={r.action}
//                       className="text-sm font-semibold underline"
//                     >
//                       Start Now →
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ---------------- COMPONENTS ---------------- */

// function ActionCard({ icon, title, desc, onClick }) {
//   return (
//     <div
//       onClick={onClick}
//       className="cursor-pointer bg-gray-800/80 border border-gray-700
//       rounded-2xl p-6 hover:border-indigo-500 transition"
//     >
//       <div className="text-indigo-400 mb-4">{icon}</div>
//       <h3 className="text-xl font-semibold text-white mb-2">
//         {title}
//       </h3>
//       <p className="text-gray-400 text-sm">{desc}</p>
//     </div>
//   );
// }

export default function Dashboard() {
  return (
    <div className="min-h-screen flex items-center justify-center
      bg-gradient-to-br from-black via-gray-950 to-black text-white">

      <div className="text-center max-w-md px-6">
        {/* Animated icon */}
        <div className="text-6xl mb-6 animate-bounce">🛠️</div>

        <h1 className="text-4xl font-extrabold mb-4">
          Under Maintenance
        </h1>

        <p className="text-gray-400 mb-6">
          Our Dashboard is temporarily unavailable due to server maintenance.
          We’re working hard to bring it back online.
        </p>

        {/* Animated loader */}
        <div className="flex justify-center gap-2 mb-6">
          <span className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></span>
          <span className="w-3 h-3 bg-blue-500 rounded-full animate-pulse delay-150"></span>
          <span className="w-3 h-3 bg-blue-500 rounded-full animate-pulse delay-300"></span>
        </div>

        <p className="text-sm text-gray-500 italic">
          Please check back again soon 🚀
        </p>
      </div>
    </div>
  );
}
